import React from 'react'
import { IconProps } from '../../../types/types'

const NewContact: React.FC<IconProps> = ({ size = '18', color = '#1E1E1E', className }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M4.5 9H13.5" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9 13.5V4.5" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default NewContact